// src/components/DatabaseExplorer/ExplorerToolbar.jsx

import React from "react";
import {
  FiDatabase,
  FiSearch,
  FiRefreshCw,
  FiFilter,
  FiX,
} from "react-icons/fi";

export default function ExplorerToolbar({
  database,
  table,
  search,
  onSearchChange,
  showFilters,
  onToggleFilters,
  onClearFilters,
  onRefresh,
  loading,
  activeFilterCount,
}) {
  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body p-3 p-md-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
          <div>
            <h5 className="fw-bold mb-1">
              <FiDatabase className="me-2 text-primary" />
              {table || "Table explorer"}
            </h5>

            <div className="small text-secondary">
              Database: {database || "Not selected"}
            </div>
          </div>

          <div className="d-flex flex-wrap gap-2">
            <button
              className={`btn btn-sm ${
                showFilters ? "btn-primary" : "btn-outline-primary"
              }`}
              type="button"
              onClick={onToggleFilters}
            >
              <FiFilter className="me-1" />
              Filters
              {activeFilterCount > 0 && (
                <span className="badge text-bg-light text-primary ms-2">
                  {activeFilterCount}
                </span>
              )}
            </button>

            <button
              className="btn btn-sm btn-outline-secondary"
              type="button"
              onClick={onClearFilters}
            >
              <FiX className="me-1" />
              Clear
            </button>

            <button
              className="btn btn-sm btn-outline-primary"
              type="button"
              onClick={onRefresh}
              disabled={loading}
            >
              <FiRefreshCw className="me-1" />
              Refresh
            </button>
          </div>
        </div>

        <div className="input-group">
          <span className="input-group-text bg-white">
            <FiSearch />
          </span>

          <input
            type="search"
            className="form-control"
            placeholder="Search all columns..."
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
          />

          {search && (
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => onSearchChange("")}
              aria-label="Clear search"
            >
              <FiX />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
